import React from 'react';
import { motion } from 'framer-motion';
import { Target, Heart, Compass, Users, UserCircle2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
const roles = [{
  title: 'Fasilitator',
  description: 'Memfasilitasi perkembangan peserta didik melalui penyediaan lingkungan yang kondusif dan program bimbingan yang relevan dengan kebutuhan siswa.',
  icon: Users,
  color: 'bg-pastel-blue-light'
}, {
  title: 'Pembimbing',
  description: 'Memberikan arahan dan panduan kepada siswa dalam menghadapi berbagai tantangan akademik, pribadi, sosial, maupun karier.',
  icon: Compass,
  color: 'bg-pastel-pink-light'
}, {
  title: 'Konselor Sekolah',
  description: 'Memberikan layanan konseling profesional untuk membantu siswa menyelesaikan masalah dan mencapai kesejahteraan psikologis (well-being).',
  icon: Heart,
  color: 'bg-pastel-grey-light'
}];
const teachers = [{
  name: 'Dra. Hj. Siti Aminah, M.Pd',
  role: 'Koordinator BK'
}, {
  name: 'Budi Santoso, S.Pd',
  role: 'Guru BK Kelas X'
}, {
  name: 'Rina Wati, S.Psi',
  role: 'Guru BK Kelas XI'
}, {
  name: 'Ahmad Fauzi, M.Pd',
  role: 'Guru BK Kelas XII'
}];
export function Profil() {
  const {
    user
  } = useAuth();
  return <div className="min-h-screen bg-white py-12" data-id="element-469">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-470">
        {/* 🔥 PROFIL USER */}
        {user && <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-16 max-w-3xl mx-auto bg-pastel-grey-light p-6 rounded-3xl shadow-sm" data-id="element-471">
            <div className="flex items-center gap-4" data-id="element-472">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm" data-id="element-473">
                <UserCircle2 size={32} className="text-gray-400" data-id="element-474" />
              </div>

              <div data-id="element-475">
                <h2 className="text-xl font-bold text-dark" data-id="element-476">Profil Saya</h2>
                <p className="text-gray-600 text-sm" data-id="element-477">Email: {user.email}</p>
              </div>
            </div>
          </motion.div>}

        {/* HEADER */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center max-w-3xl mx-auto mb-20" data-id="element-478">
          <h1 className="text-4xl font-bold text-dark mb-6" data-id="element-479">
            Profil Bimbingan & Konseling
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed" data-id="element-480">
            Website Bimbingan dan Konseling ini hadir sebagai inovasi layanan
            digital untuk mempermudah akses siswa terhadap layanan BK. Kami
            berkomitmen untuk mendampingi setiap langkah perkembangan peserta
            didik menuju masa depan yang gemilang.
          </p>
        </motion.div>

        {/* VISI MISI */}
        <div className="grid md:grid-cols-2 gap-8 mb-24" data-id="element-481">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="p-8 rounded-3xl bg-pastel-blue-light/50 border border-pastel-blue" data-id="element-482">
            <div className="flex items-center gap-4 mb-6" data-id="element-483">
              <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center" data-id="element-484">
                <Target className="text-blue-600" data-id="element-485" />
              </div>
              <h2 className="text-2xl font-bold text-dark" data-id="element-486">Visi</h2>
            </div>
            <p className="text-gray-700" data-id="element-487">
              Mewujudkan layanan Bimbingan dan Konseling yang profesional,
              inovatif, dan komprehensif untuk memfasilitasi perkembangan
              kemandirian peserta didik.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="p-8 rounded-3xl bg-pastel-pink-light/50 border border-pastel-pink" data-id="element-488">
            <div className="flex items-center gap-4 mb-6" data-id="element-489">
              <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center" data-id="element-490">
                <Compass className="text-pink-600" data-id="element-491" />
              </div>
              <h2 className="text-2xl font-bold text-dark" data-id="element-492">Misi</h2>
            </div>
            <ul className="space-y-3 text-gray-700" data-id="element-493">
              <li data-id="element-494">• Layanan BK yang memandirikan siswa</li>
              <li data-id="element-495">• Kolaborasi dengan stakeholder sekolah</li>
              <li data-id="element-496">• Inovasi berbasis teknologi</li>
            </ul>
          </motion.div>
        </div>

        {/* PERAN BK */}
        <div className="mb-24" data-id="element-497">
          <div className="text-center mb-12" data-id="element-498">
            <h2 className="text-3xl font-bold text-dark mb-4" data-id="element-499">Peran Guru BK</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-500">
            {roles.map((role, index) => {
            const Icon = role.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} className="p-8 rounded-3xl bg-white border shadow-sm" data-id="element-501">
                  <div className="mb-4" data-id="element-502">
                    <Icon className="w-7 h-7 text-dark" data-id="element-503" />
                  </div>
                  <h3 className="font-semibold text-lg mb-2" data-id="element-504">{role.title}</h3>
                  <p className="text-gray-600" data-id="element-505">{role.description}</p>
                </motion.div>;
          })}
          </div>
        </div>

        {/* GURU */}
        <div data-id="element-506">
          <h2 className="text-3xl font-bold text-dark mb-8 text-center" data-id="element-507">
            Struktur BK
          </h2>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-508">
            {teachers.map((teacher, index) => <motion.div key={index} className="p-6 bg-gray-50 rounded-2xl text-center" data-id="element-509">
                <UserCircle2 size={48} className="mx-auto mb-3 text-gray-400" data-id="element-510" />
                <h3 className="font-semibold" data-id="element-511">{teacher.name}</h3>
                <p className="text-sm text-gray-500" data-id="element-512">{teacher.role}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </div>;
}